module.exports = __webpack_public_path__ + "static/media/6.3fe4e755.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cats/6.jpg
// module id = 211
// module chunks = 0